$(document).ready(function() {
    Waves.init();
    Waves.attach('.flat-icon', ['waves-circle']);
    Waves.attach('.button', ['waves-button', 'waves-float']);

    $('form .form-control').each(function() {
        if ($(this).val() !== '') $(this).parents('.form-group').addClass('active');
    });
    $('form .form-control').focus(function() {
        $(this).parents('.form-group').addClass('active');
    });
    $('form .form-control').blur(function() {
        if ($(this).val() === '') {
            $(this).parents('.form-group').removeClass('active');
        }
    });


    $('.menu .dropdown a').click(function() {
        $(this).siblings('ul').slideToggle('fast');
    });

    $('.search').click(function() {
        $(this).siblings('form').toggleClass('active');
        setTimeout(function() {
            $('.form-search.active input').focus();
        }, 500);
    });
    $('.material-grid').click(function() {
        $('body').toggleClass('active');
    });

    $("section.material-green").mouseup(function() {
        if ($(".material-green div.material-icon").hasClass("hamburger")) {
            $(".material-green div.material-icon").removeClass("hamburger").addClass("arrow");
        } else {
            $(".material-green div.material-icon").removeClass("arrow").addClass("hamburger");
        }

    });
    $('.selectpicker').on('loaded.bs.select', function(e){
      $('form .bootstrap-select').click(function () {
        $(this).parents('.form-group').addClass('active');
      });
    });
    $('.selectpicker').on('hidden.bs.select', function (e) {
       $(this).parents('.form-group').removeClass('active');
    });
});
